module.exports = __webpack_public_path__ + "img/info_processed.56e9a129.svg";